import { render, staticRenderFns } from "./HSSRabattForm.vue?vue&type=template&id=89ca8704&"
import script from "./HSSRabattForm.vue?vue&type=script&lang=js&"
export * from "./HSSRabattForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports